import { render, staticRenderFns } from "./Rutas.vue?vue&type=template&id=449e606e"
import script from "./Rutas.vue?vue&type=script&lang=js"
export * from "./Rutas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports